// extracted by mini-css-extract-plugin
module.exports = {"title":"OverachieverDialog__title___HE9cp","description":"OverachieverDialog__description___y2Vp0","bold":"OverachieverDialog__bold___w8zbV"};